import { lazy, Suspense, useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from '@components/layout/Layout'
import { useThemeStore } from '@stores/themeStore'
import { useAuthStore } from '@stores/authStore'

const AnalyticsPage = lazy(() => import('@/pages/AnalyticsPage'))
const BacklinksPage = lazy(() => import('@/pages/BacklinksPage'))
const BrandMonitorPage = lazy(() => import('@/pages/BrandMonitorPage'))
const ContentCalendarPage = lazy(() => import('@/pages/ContentCalendarPage'))
const DashboardPage = lazy(() => import('@/pages/DashboardPage'))
const GitHubSeoPage = lazy(() => import('@/pages/GitHubSeoPage'))
const LoginPage = lazy(() => import('@/pages/LoginPage'))
const SettingsPage = lazy(() => import('@/pages/SettingsPage'))
const SubmissionsPage = lazy(() => import('@/pages/SubmissionsPage'))
const TrackingPage = lazy(() => import('@/pages/TrackingPage'))

function RequireAuth({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return <>{children}</>
}

function App() {
  const initializeTheme = useThemeStore((state) => state.initializeTheme)

  useEffect(() => {
    initializeTheme()
  }, [initializeTheme])

  return (
    <Suspense fallback={<div className="flex items-center justify-center h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" /></div>}>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="tracking" element={<TrackingPage />} />
        <Route path="submissions" element={<SubmissionsPage />} />
        <Route path="backlinks" element={<BacklinksPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="content" element={<ContentCalendarPage />} />
        <Route path="brand" element={<BrandMonitorPage />} />
        <Route path="github-seo" element={<GitHubSeoPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
    </Suspense>
  )
}

export default App
